export const IMAGE_PLACEHOLDER = 'https://placehold.co/600x400';
